"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickStatic = void 0;
const findFilterByKey_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findFilterByKey"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const Swatch_1 = __importDefault(require("@opsbase/web-ui/Swatch"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    root: {
        borderLeft: '5px solid white',
        '&:hover': {
            borderColor: lib_palette_1.default.secondary.main,
        },
    },
});
function PickStatic(props) {
    const { onSelect, fieldOptions, filters } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null, fieldOptions.map(fieldOption => {
        const isSelected = !!(0, findFilterByKey_1.default)(filters, fieldOption.queryFieldKey, fieldOption.id);
        return (react_1.default.createElement(MenuItem_1.default, { key: fieldOption.id, maxWidth: 240, onClick: e => onSelect(fieldOption, e), classes: { root: myCss.root }, label: fieldOption.title, showTick: isSelected }, fieldOption.color && react_1.default.createElement(Swatch_1.default, { color: fieldOption.color })));
    }))), [fieldOptions, filters, myCss, onSelect]);
}
exports.PickStatic = PickStatic;
exports.default = PickStatic;
